import * as firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/firestore';


var firebaseConfig = {
  apiKey: "AIzaSyC_PJc9VbDexdk0pfl6Ur7YTEkm8ygaST0",
  authDomain: "backup-a2084.firebaseapp.com",
  projectId: "backup-a2084",
  storageBucket: "backup-a2084.appspot.com",
  messagingSenderId: "608013661080",
  appId: "1:608013661080:web:7e32c99f32cbbf6ec0f1ed"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const projectStorage = firebase.storage();
const projectFirestore = firebase.firestore();
const timestamp = firebase.firestore.FieldValue.serverTimestamp;

export { projectStorage, projectFirestore, timestamp };